import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreditDebitNotesModalService {

  private selectedCreditDebitNoteSubject = new BehaviorSubject<any>(null);
  public selectedCreditDebitNote$ = this.selectedCreditDebitNoteSubject.asObservable();

  constructor() { }

  setSelectedCreditDebitNote(creditDebitNote: any): void {
    this.selectedCreditDebitNoteSubject.next(creditDebitNote);
  }

  getSelectedCreditDebitNote(): any | null {
    return this.selectedCreditDebitNoteSubject.value;
  }

  clearSelectedCreditDebitNote(): void {
    this.selectedCreditDebitNoteSubject.next(null);
  }
}
